import { render, staticRenderFns } from "./LayerLegendImageCustom.vue?vue&type=template&id=3d1f1922&"
import script from "./LayerLegendImageCustom.vue?vue&type=script&lang=js&"
export * from "./LayerLegendImageCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports